<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <v-row>
          <v-col cols="12" md="12">
            <div class="rowinfo">
              <v-autocomplete
                :error-messages="errorPhone"
                :items="city"
                append-icon="mdi-map-marker"
                clear-icon="mdi-close-circle-outline"
                dense
                item-text="name"
                item-value="id"
                :label="$t('province')"
                outlined
                :placeholder="$t('search_city_placeholder')"
                class="contentinfo"
                @input="getProv($event)"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-name-id`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('search_city_label')"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import { rbAxios, rbland, RobotAxios } from "@/main";

export default {
  name: "citySelector",
  props: {
    value: {
      type: Object,
      default: {
        city: "",
        province: "",
      },
    },
    searchFn: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "city-selector",
      city: [],
      neighborhood: [],
      errorPhone: "",
      loadCity: false,
      errorNeighbor: "",
      a: [],
      cityInfo: {
        city: "root",
        neighborhood: "",
      },
    };
  },
  methods: {
    getProvince: function () {
      rbland.get(`divar/cities`).then((res) => {
        localStorage.setItem("province", JSON.stringify(res.data.data));
        this.city = res.data.data;
      });
    },
    getCities: function (value) {
      this.loadCity = true;
      rbland
        .get(`divar/districts/${value}`)
        .then((res) => {
          this.loadCity = false;
          this.neighborhood = res.data.data;
        })
        .finally(() => {
          this.loadCity = false;
        });
    },
    getCity(val) {
      this.cityInfo.city = val;
    },
    getNeighbor(val) {
      this.value.city = this.neighborhood.find((item) => item.id === val);
      this.$emit("input", this.value);
      this.searchFn();
    },
    getProv(val) {
      this.value.province = this.city.find((item) => item.id === val);
      this.$emit("input", this.value);
      this.searchFn();
    },
  },
  watch: {
    value: {
      handler() {
        this.$emit("input", this.value);
      },
      deep: true,
    },
  },
  mounted() {
    if (!localStorage.getItem("province")) this.getProvince();
    else this.city = JSON.parse(localStorage.getItem("province"));
  },
};
</script>
<style scoped></style>
